export {
  componentMap,
  getComponent,
  registerComponent,
} from './componentMap';

export {
  componentMetaMap,
  getComponentMeta,
  getAllComponentMetas,
  registerComponentMeta,
} from './componentMetaMap';
import type { PagePlatform } from "@mijalowcode/types";
import {
  getAllComponentMetas,
  getComponentMeta,
} from "./componentMetaMap";
import {
  getAllH5ComponentMetas,
  getH5ComponentMeta,
} from "./h5/componentMetaMap";

export function getComponentMetaByPlatform(
  componentName: string,
  platform: PagePlatform,
) {
  return platform === "h5"
    ? getH5ComponentMeta(componentName)
    : getComponentMeta(componentName);
}

export function getAllComponentMetasByPlatform(platform: PagePlatform) {
  return platform === "h5"
    ? getAllH5ComponentMetas()
    : getAllComponentMetas();
}

export { getAllH5ComponentMetas, getH5ComponentMeta };

export {
  collectSlotChildren,
  renderSlotArea,
  resolveSlot,
  useSlotRuntime,
  type SlotArea,
} from "./slot-runtime";

export { useEventEmitter, type EventEmitter } from "./event-runtime";

export { columnsRequestAdapter } from "./runtime-adapters/columns-request";
export { listTemplateAdapter } from "./runtime-adapters/list-template";
export { defaultComponentAdapterRegistry } from "./runtime-adapters";
export { default as ListWrapper } from "./antd/List/ListWrapper";

export {
  clearMaterialLoadCache,
  loadMaterialModules,
  materialManifest,
  type LoadMaterialModulesOptions,
  type LoadedMaterialModules,
  type MaterialLoadOptions,
  type MaterialManifest,
  type MaterialManifestEntry,
  type MaterialRuntimeModule,
} from "./material-manifest";
